export default "/images/5913f1773f1b402d82bad136a006de22.avif";